var path = '/pages/guestlists/views/pages/guestlists/centerstage.tpl.html';
var html = "<div class=\"content-box\" ng-if=\"vm.loading\">\n    <al-loader size=\"medium\"></al-loader>\n</div>\n<div ng-if=\"!vm.loading\" ng-init=\"vm._startIframe()\" class=\"center-stage-iframe-container\">\n    <iframe id=\"center-stage-iframe\" />\n</div>\n\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/guestlists/centerstage.tpl.html
// module id = 2257
// module chunks = 1